export default __webpack_public_path__ + "img/Inter-LightItalic_5336b8e.woff2";